<main class="auth-page min-vh-100 bg-white text-dark">
  <div class="row g-0 min-vh-100">
    <section class="col-lg-6 auth-brand-panel text-white p-4 p-lg-4 d-none d-lg-flex flex-column justify-content-between overflow-hidden position-relative bg-dark">
      <router-link to="/" class="auth-brand-mark d-inline-flex mb-3 align-self-start bg-white rounded-3 p-2" aria-label="Siyanda Platinum home">
        <span class="auth-brand-mark-img d-block" role="img" aria-label="Siyanda Bakgatla Platinum Mine"></span>
      </router-link>

      <div>
        <p class="text-uppercase text-warning fw-bold text-xxs mb-2">Account recovery</p>
        <h1 class="h3 fw-bold mb-2">Create a secure new password.</h1>
        <p class="text-white-50 mb-0">
          Choose a new password to protect access to the Siyanda Platinum Platform.
        </p>
      </div>

      <div>
        <hr class="my-3" />
        <div class="row g-3">
          <div class="col-4">
            <span class="d-block text-uppercase text-white-50 text-xxs mb-1">Production</span>
            <span class="d-block fw-bold text-warning">Tracked daily</span>
          </div>
          <div class="col-4">
            <span class="d-block text-uppercase text-white-50 text-xxs mb-1">Safety</span>
            <span class="d-block fw-bold text-warning">Always on</span>
          </div>
          <div class="col-4">
            <span class="d-block text-uppercase text-white-50 text-xxs mb-1">Sustainability</span>
            <span class="d-block fw-bold text-warning">Community first</span>
          </div>
        </div>
      </div>
    </section>

    <section class="col-lg-6 bg-white text-dark d-flex align-items-center justify-content-center p-4 p-md-5">
      <div class="col-12 col-sm-10 col-md-8 col-lg-9 col-xl-7">
        <h2 class="h3 fw-bold mb-2">Set a new password</h2>
        <p class="text-secondary mb-4">Use at least 8 characters for your new password.</p>

        <SnackbarMessage
          :error-message="error_message"
          :success-message="success_message"
          @dismiss-error="error_message = ''"
          @dismiss-success="success_message = ''"
        />

        <div v-if="is_loading" class="text-center mb-3">
          <div class="spinner-border spinner-border-sm me-2 text-primary"></div>
          <span class="text-secondary">Updating password...</span>
        </div>

        <form v-if="!is_loading" @submit.prevent="submitNewPassword">
          <div class="mb-3">
            <label class="form-label fw-bold text-xs" for="new-password">New password</label>
            <div class="input-group">
              <input
                id="new-password"
                v-model="password"
                :type="password_input_type"
                class="form-control"
                placeholder="Enter your new password"
                autocomplete="new-password"
                required
              />
              <button
                type="button"
                class="btn btn-outline-secondary"
                @click="toggle_change_password_type"
                :aria-label="password_input_type === 'password' ? 'Show passwords' : 'Hide passwords'"
              >
                <i :class="password_input_type === 'password' ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
              </button>
            </div>
          </div>

          <div class="mb-4">
            <label class="form-label fw-bold text-xs" for="confirm-password">Confirm password</label>
            <div class="input-group">
              <input
                id="confirm-password"
                v-model="confirmPassword"
                :type="password_input_type"
                class="form-control"
                placeholder="Confirm your new password"
                autocomplete="new-password"
                required
              />
              <button
                type="button"
                class="btn btn-outline-secondary"
                @click="toggle_change_password_type"
                :aria-label="password_input_type === 'password' ? 'Show passwords' : 'Hide passwords'"
              >
                <i :class="password_input_type === 'password' ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
              </button>
            </div>
          </div>

          <button class="btn btn-primary w-100 py-2 mb-3" :disabled="is_loading">
            Save new password
          </button>

          <p class="text-center text-secondary small mb-0">
            Remember your password?
            <router-link to="/login" class="fw-semibold text-primary">
              Sign in
            </router-link>
          </p>
        </form>
      </div>
    </section>
  </div>
</main>
